import {FC} from 'react';
import {SwitcherBlock, SwitcherWrapper} from "@atoms/Switcher.styles";
import Text from "@atoms/Text";

export interface SwitcherProps {
  onClick: () => void;
  checked?: boolean;
  label?: string;
  disabled?: boolean;
}

const Switcher: FC<SwitcherProps> = ({
  onClick,
  checked,
  label,
  disabled,
}) => {
  return (
    <SwitcherWrapper checked={checked}>
      <SwitcherBlock checked={checked} disabled={disabled} onClick={onClick} label={label} />
      {label && <Text text={label} />}
    </SwitcherWrapper>
  );
};

export default Switcher;
